import { createFileRoute, Link } from "@tanstack/react-router";
import { useState } from "react";

import { EmailLinkForm } from "~/components/auth/email-link-form";
import { AuthCard, AuthIntro, AuthLinks } from "~/components/shell/auth-layout";
import { TextButton, textLinkClass } from "~/components/ui/text-button";
import { Note } from "~/components/ui/typography";

export const Route = createFileRoute("/(public)/aanmelden/$enrollCode/")({
  component: EmailStep,
});

function EmailStep() {
  const { enrollCode } = Route.useParams();
  const [sentTo, setSentTo] = useState<string | null>(null);

  if (sentTo !== null) {
    return (
      <>
        <AuthCard>
          <AuthIntro as="h2" title="Check je e-mail">
            We hebben een link gestuurd naar <b>{sentTo}</b>. Klik op de link om je
            e-mailadres te bevestigen en je bedrijfsgegevens in te vullen.
          </AuthIntro>
          <Note>Geen mail ontvangen? Kijk ook in je spammap.</Note>
        </AuthCard>
        <AuthLinks>
          <TextButton onClick={() => setSentTo(null)}>
            Ander e-mailadres gebruiken
          </TextButton>
        </AuthLinks>
      </>
    );
  }

  return (
    <>
      <AuthCard>
        <AuthIntro as="h2" title="Bevestig je e-mailadres">
          Hiermee log je later in op het wervingsportaal. We sturen je een link om het
          adres te bevestigen; een wachtwoord heb je niet nodig.
        </AuthIntro>
        <EmailLinkForm
          enrollCode={enrollCode}
          label="Zakelijk e-mailadres"
          submitLabel="Doorgaan"
          onSent={setSentTo}
        />
      </AuthCard>
      <AuthLinks>
        <span>
          Al ingeschreven?{" "}
          <Link to="/inloggen" className={textLinkClass}>
            Log in
          </Link>
        </span>
      </AuthLinks>
    </>
  );
}
